import { useCallback } from 'react';
import { RsiData, RsiTableOnErrorCallback, RsiTableValidator } from '../../../Types';
import { useImportersIntl } from '../../../translations/useImportersIntl';
import { useValidateEngagementTableApi } from '../../../validations/impl/engagementRetroactiveChange/useValidateRowAgainstRetroactiveEngagementChange';
import { isInvalidField, sanitizeRsiArrayData, sanitizeRsiData } from '../validationUtils';

export function useValidateTableAgainstRetroactiveEngagementChange(): RsiTableValidator {
  const api = useValidateEngagementTableApi();
  const { invalidField } = useImportersIntl();

  return useCallback(
    async (table: RsiData[], addError: RsiTableOnErrorCallback) => {
      const response = await api.get({
        variables: {
          input: {
            values: table.map((data, index) => ({
              index,
              urnToValueMap: sanitizeRsiData(data),
              urnToValuesMap: sanitizeRsiArrayData(data)
            }))
          }
        }
      });
      response.data?.result.validations?.forEach((item) => {
        if (isInvalidField(item)) {
          addError(item.index ?? 0, item.urn, { level: 'error', message: item.result.message ?? invalidField });
        }
      });
    },
    [api, invalidField]
  );
}
